import * as St from './ToolbarItem.styles';
import DuplicateIcon from '/public/assets/icons/Copy button.svg';
import RedoIcon from '/public/assets/icons/Redo.svg';
import RotateClockwiseIcon from '/public/assets/icons/Rotate Clockwise.svg';
import RotateCounterClockwiseIcon from '/public/assets/icons/Rotate Counter Clockwise.svg';
import UndoIcon from '/public/assets/icons/Undo.svg';
import ZoomInIcon from '/public/assets/icons/Zoom In.svg';
import ZoomOutIcon from '/public/assets/icons/Zoom Out.svg';
import ZoomToFitIcon from '/public/assets/icons/Zoom to Fit.svg';
import RemoveIcon from '/public/assets/icons/delete.svg';

import { TOOLBAR } from '~/core/enums';

type ToolbarItemProps = {
  name: TOOLBAR;
  isEnabled: boolean;
  onClick: () => void;
};

const ToolbarItem = ({
  name,
  isEnabled,
  onClick,
}: ToolbarItemProps): JSX.Element => {
  const Icon = buttons[name];

  return (
    <St.Container disabled={!isEnabled} onClick={() => isEnabled && onClick()}>
      <Icon />
    </St.Container>
  );
};

const buttons: Record<TOOLBAR, React.ComponentType> = {
  [TOOLBAR.UNDO]: UndoIcon,
  [TOOLBAR.REDO]: RedoIcon,
  [TOOLBAR.ROTATE_CLOCKWISE]: RotateClockwiseIcon,
  [TOOLBAR.ROTATE_COUNTERCLOCKWISE]: RotateCounterClockwiseIcon,
  [TOOLBAR.DUPLICATE]: DuplicateIcon,
  [TOOLBAR.REMOVE]: RemoveIcon,
  [TOOLBAR.ZOOM_IN]: ZoomInIcon,
  [TOOLBAR.ZOOM_OUT]: ZoomOutIcon,
  [TOOLBAR.ZOOM_TO_FIT]: ZoomToFitIcon,
};

export default ToolbarItem;
